<template>
  <!-- 选择城市弹窗 -->
  <div class="invite-box">
    <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        width="31%">
      <div class="g-text-center main-text g-font-20 g-font-weight-5">
        请选择城市
      </div>
      <div class="cut-line"></div>
      <div class="g-flex">
        <div class="left-menu">
          <div class="menu-item g-flex g-row-between"
               @click="selectMenu(item,index)"
               :class="{'active-menu':menuIndex === index}"
               v-for="(item,index) in list" :key="index">
            <p class="g-font-14 g-nowrap">{{ item.dictValue }}</p>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="right-tags">
          <div class="g-p-b-20 g-full-width" v-for="(item,index) in list[menuIndex].children" :key="index">
            <p class="g-font-14 main-text g-font-weight-5">{{item.dictValue}}</p>
            <div class="tag-list g-flex g-flex-wrap">
              <div class="tag-item"
                   @click="selectCity(sub)"
                   :class="{'active-tag':selectedList.findIndex(val => val.dictKey === sub.dictKey) !== -1}"
                   v-for="(sub,subIndex) in item.children" :key="subIndex">
                {{sub.dictValue}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="g-flex g-row-center g-m-t-30">
        <div class="submit-btn g-flex g-row-center" @click="doSubmit">确定</div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "city-popup",
  props: ['list'],
  data() {
    return {
      dialogVisible: false,
      selectedList:[],//已选中分类
      selected:'',//已选中的分类
      menuIndex:0,//当前选中的菜单下标
    }
  },
  methods: {
    // 开启
    open() {
      this.dialogVisible = true
    },
    // 关闭
    close() {
      this.dialogVisible = false
    },
    //选择城市
    selectCity(val) {
      //多选操作
	  //debugger
      let arrIndex = this.selectedList.findIndex(item => val.dictKey === item.dictKey)
      if(arrIndex === -1){
        this.selectedList.push(val)
      }else {
        this.selectedList.splice(arrIndex,1)
      }
      console.log(this.selectedList)
    },
    // 选择菜单
    selectMenu(val,idx){
      this.menuIndex = idx
    },
    // 提交
    doSubmit() {
		
      this.$emit('submit', JSON.parse(JSON.stringify(this.selectedList)))
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 0 !important;
}

.cut-line {
  margin: 15px 0 20px;
  background: #f7f7f7;
  height: 1px;
}

.left-menu {
  width: 30%;
  height: 220px;
  overflow-y: scroll;

  .menu-item {
    padding: 8px 10px;
    cursor: pointer;
    margin-right: 4px;
    color: #8D92A1;
    font-size: 14px;

    &:hover{
      background: #f6f6f8;
      transition: all ease-in 0.2s;
    }
  }

  .active-menu{
    background: #f6f6f8;
    transition: all ease-in 0.2s;
  }
}


.right-tags {
  width: 65%;
  margin-left: 5%;
  height: 220px;
  overflow-y: scroll;

  .tag-item{
    padding: 4px 18px;
    border-radius: 5px;
    color: #999;
    background: #f6f6f8;
    margin: 10px 10px 0 0;
    cursor: pointer;
    &:hover{
      color: #fff;
      background: #407aff;
      transition: all ease-in 0.2s;
    }
  }

  .active-tag{
    color: #fff;
    background: #407aff;
    transition: all ease-in 0.2s;
  }
}

.submit-btn{
  padding: 6px 30px;
}
</style>